// Cart Bundle Upsell - Improved Version with Smooth Updates
(function() {
    'use strict';
    
    console.log('Bundle script loading...');
    
    const config = {
        bundleImageUrl: 'https://cdn.shopify.com/s/files/1/0616/3549/4093/files/Vero_Bundle_CTA.png?v=1748491876',
        bundleTitle: '2 FOR $160!',
        bundleSubtitle: 'Bundle & Save 20% with our special offer',
        bundlePrice: '$200.00',
        bundleSalePrice: '$160'
    };
    
    // Simple bundle HTML
    function createBundleHTML() {
        return `
            <div class="cd-cart-bundle-upsell" style="
                padding: 12px;
                border: 1px solid #e0e0e0;
                background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                position: relative;
                opacity: 0;
                transform: translateY(10px);
                transition: all 0.3s ease;
            ">
                <div style="
                    position: absolute;
                    top: -12px;
                    right: 12px;
                    background: #702F7E;
                    color: white;
                    padding: 4px 10px;
                    border-radius: 3px;
                    font-size: 11px;
                    font-weight: bold;
                    text-transform: uppercase;
                ">Save $40.00</div>
                
                <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
                    <img src="${config.bundleImageUrl}" style="
                        width: 100px;
                        height: 100px;
                        object-fit: contain;
                        border-radius: 10px;
                        background: #ffffff;
                    ">
                    
                    <div style="flex: 1;">
                        <p style="font-size: 16px; font-weight: bold; color: #333;">
                            ${config.bundleTitle}
                        </p>
                        <p style="font-size: 13px; color: #666;">
                            ${config.bundleSubtitle}
                        </p>
                        <div style="display: flex; align-items: center; gap: 6px;">
                            <span style="text-decoration: line-through; color: #999; font-size: 13px;">
                                ${config.bundlePrice}
                            </span>
                            <span style="color: #702F7E; font-size: 18px; font-weight: bold;">
                                ${config.bundleSalePrice}
                            </span>
                        </div>
                    </div>
                </div>
                
                <button onclick="addSecondItem()" style="
                    background: #f5f5f5;
                    color: black;
                    border: 1px solid black;
                    padding: 5px 27px;
                    height: 48px;
                    font-size: 13px;
                    font-weight: bold;
                    cursor: pointer;
                    width: 100%;
                    text-transform: uppercase;
                    border-radius: 4px;
                    transition: all 0.2s ease;
                " onmouseover="this.style.background='#e5e5e5'" onmouseout="this.style.background='#f5f5f5'">SAVE NOW</button>
            </div>
        `;
    }
    
    // Simple wholesale HTML
    function createWholesaleHTML() {
        return `
            <div class="cd-cart-wholesale-cta" style="
                padding: 12px 16px;
                border: 1px solid #ddd;
                background: #f9f9f9;
                text-align: center;
                font-size: 14px;
                color: #666;
                opacity: 0;
                transform: translateY(10px);
                transition: all 0.3s ease;
            ">
                <p style="margin: 0;">
                    Planning to buy in bulk? 
                    <a href="https://veroankle.com/pages/contact?inquiry=wholesale" style="color: #702F7E; text-decoration: underline; font-weight: 500;">
                        Apply for wholesale pricing!
                    </a>
                </p>
            </div>
        `;
    }
    
    // Get quantity by counting actual cart items
    function getQuantity() {
        const cartItems = document.querySelectorAll('.cd-cart-item');
        let totalQty = 0;
        
        if (cartItems.length > 0) {
            cartItems.forEach(item => {
                const qtyInput = item.querySelector('.cd-cart-quantity input[type="text"]');
                if (qtyInput) {
                    const qty = parseInt(qtyInput.value) || 1;
                    totalQty += qty;
                } else {
                    totalQty += 1;
                }
            });
            
            console.log('Found', cartItems.length, 'cart items with total quantity:', totalQty);
            return totalQty;
        }
        
        console.log('No cart items found');
        return 0;
    }
    
    // Refresh cart content without page reload
    function refreshCartContent() {
        return new Promise((resolve, reject) => {
            fetch(window.location.href, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Find cart content areas to update
                const currentCartInner = document.querySelector('.cd-cart-inner');
                const newCartInner = doc.querySelector('.cd-cart-inner');
                
                const currentCartTotal = document.querySelector('.cd-cart-total, .cart-total');
                const newCartTotal = doc.querySelector('.cd-cart-total, .cart-total');
                
                if (currentCartInner && newCartInner) {
                    // Smoothly update cart content
                    currentCartInner.style.opacity = '0.5';
                    currentCartInner.style.transition = 'opacity 0.2s ease';
                    
                    setTimeout(() => {
                        currentCartInner.innerHTML = newCartInner.innerHTML;
                        currentCartInner.style.opacity = '1';
                        
                        // Update cart total if found
                        if (currentCartTotal && newCartTotal) {
                            currentCartTotal.innerHTML = newCartTotal.innerHTML;
                        }
                        
                        console.log('Cart content refreshed smoothly');
                        resolve();
                    }, 200);
                } else {
                    console.log('Cart content not found for refresh');
                    reject('Cart content not found');
                }
            })
            .catch(error => {
                console.error('Error refreshing cart:', error);
                reject(error);
            });
        });
    }
    
    // Add second item function - just click the existing plus button!
    window.addSecondItem = function() {
        console.log('Adding second item by clicking plus button...');
        
        const button = document.querySelector('.cd-cart-bundle-upsell button');
        if (button) {
            button.textContent = 'ADDING...';
            button.disabled = true;
            button.style.opacity = '0.7';
        }
        
        // Find and click the existing plus button in the cart
        const plusButton = document.querySelector('.cd-cart-quantity-plus');
        
        if (plusButton) {
            console.log('Found plus button, clicking it...');
            
            // Smooth fade out of bundle upsell
            const bundleEl = document.querySelector('.cd-cart-bundle-upsell');
            if (bundleEl) {
                bundleEl.style.opacity = '0';
                bundleEl.style.transform = 'translateY(-10px)';
                setTimeout(() => bundleEl.remove(), 300);
            }
            
            // Click the plus button
            plusButton.click();
            
            // Update our state immediately
            setTimeout(() => {
                currentState = { qty: 2, displayType: 'none' };
                console.log('✅ Bundle applied by clicking plus button');
            }, 100);
            
        } else {
            console.error('Plus button not found in cart');
            alert('Error: Could not find cart controls');
            
            if (button) {
                button.textContent = 'SAVE NOW';
                button.disabled = false;
                button.style.opacity = '1';
            }
        }
    };
    
    // Smooth element insertion helper
    function insertElementSmoothly(element, parent, referenceNode) {
        parent.insertBefore(element, referenceNode);
        
        // Trigger smooth animation
        requestAnimationFrame(() => {
            element.style.opacity = '1';
            element.style.transform = 'translateY(0)';
        });
    }
    
    // Track current state to prevent unnecessary updates
    let currentState = { qty: -1, displayType: null };
    let wholesaleShown = false; // Flag to keep wholesale message persistent
    
    // Main update function with state tracking to prevent redundant animations
    function updateDisplay() {
        const qty = getQuantity();
        const footer = document.querySelector('.cd-cart-footer');
        
        if (!footer) {
            console.log('Footer not found');
            return;
        }
        
        // Determine what should be displayed
        let targetDisplayType = null;
        if (qty === 1) {
            targetDisplayType = 'bundle';
            wholesaleShown = false; // Reset wholesale flag when back to 1 item
        } else if (qty >= 3) {
            targetDisplayType = 'wholesale';
        } else {
            targetDisplayType = 'none';
        }
        
        // Special case: if wholesale was already shown, keep it (don't re-animate)
        if (targetDisplayType === 'wholesale' && wholesaleShown) {
            console.log('Wholesale already shown, keeping it stable');
            return;
        }
        
        // Only update if state actually changed
        if (currentState.qty === qty && currentState.displayType === targetDisplayType) {
            console.log('No state change, skipping update');
            return;
        }
        
        console.log('State changed:', currentState, '→', {qty, displayType: targetDisplayType});
        
        // Update current state
        currentState = { qty, displayType: targetDisplayType };
        
        // Remove any existing elements smoothly
        const existingBundle = document.querySelector('.cd-cart-bundle-upsell');
        const existingWholesale = document.querySelector('.cd-cart-wholesale-cta');
        
        if (existingBundle) {
            existingBundle.style.opacity = '0';
            existingBundle.style.transform = 'translateY(-10px)';
            setTimeout(() => existingBundle.remove(), 300);
            console.log('Smoothly removing existing bundle');
        }
        
        if (existingWholesale && targetDisplayType !== 'wholesale') {
            existingWholesale.style.opacity = '0';
            existingWholesale.style.transform = 'translateY(-10px)';
            setTimeout(() => existingWholesale.remove(), 300);
            console.log('Smoothly removing existing wholesale');
            wholesaleShown = false;
        }
        
        // Show appropriate content based on quantity with smooth animations
        setTimeout(() => {
            if (targetDisplayType === 'bundle') {
                const html = createBundleHTML();
                const div = document.createElement('div');
                div.innerHTML = html;
                const bundleElement = div.firstElementChild;
                
                insertElementSmoothly(bundleElement, footer.parentNode, footer);
                console.log('✅ Showing bundle upsell for 1 item');
                
            } else if (targetDisplayType === 'wholesale' && !wholesaleShown) {
                const html = createWholesaleHTML();
                const div = document.createElement('div');
                div.innerHTML = html;
                const wholesaleElement = div.firstElementChild;
                
                insertElementSmoothly(wholesaleElement, footer.parentNode, footer);
                wholesaleShown = true; // Mark as shown
                console.log('✅ Showing wholesale CTA for', qty, 'items');
                
            } else {
                console.log('✅ No upsell shown for', qty, 'items');
            }
        }, existingBundle || (existingWholesale && targetDisplayType !== 'wholesale') ? 350 : 0);
    }
    
    // Initialize with better state management
    function init() {
        console.log('Initializing...');
        
        // Reset state on init
        currentState = { qty: -1, displayType: null };
        wholesaleShown = false;
        
        setTimeout(updateDisplay, 100);
        
        // Less aggressive checking - only when needed
        let lastQty = -1;
        function checkForChanges() {
            const currentQty = getQuantity();
            if (currentQty !== lastQty) {
                console.log('Quantity changed from', lastQty, 'to', currentQty);
                lastQty = currentQty;
                updateDisplay();
            }
        }
        
        // Check less frequently to prevent spam
        setInterval(checkForChanges, 800);
        
        // Listen for cart-related events if available
        document.addEventListener('cart:updated', () => {
            console.log('Cart updated event received');
            setTimeout(updateDisplay, 100);
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();